// extracted by mini-css-extract-plugin
export default {"Header_Cnt":"COM001F1_Header_Cnt__R6tXK","portalLogo":"COM001F1_portalLogo__AtEtc","infoBox":"COM001F1_infoBox__A4cyU"};